import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { loginUser } from "./Users-Api";

import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { imageUrl, normalizarEmail } from "../../util/Functions";
import { useState } from "react";

import { cargarCursoActivo } from "../CursoAcademico/CursoAcademico-Api";
import { setCredentialsLS } from "../../util/LocalStorageUtils";
import IaxAccessRequest from "../UIComponents/IaxAccessRequest";
import { toast, ToastContainer } from "react-toastify";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.iax.es/">
        IESCloud v.1.10 · build-60
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignIn({ userLogged, setUserLogged, setTitulo }) {
  const [msglogin, setMsglogin] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleAccept = (resultado) => {
    setOpen(false);
    if (resultado.resultCode === "OK") {
      toast.success(resultado.resultDesc);
    } else {
      toast.error(resultado.resultDesc);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const credentials = {
      email: normalizarEmail(data.get("email")),
      password: data.get("password"),
    };
    const response = await loginUser(credentials);
    console.log(response);
    if (response.resultCode === "OK") {
      setUserLogged(response);
      setCredentialsLS(credentials);
      cargarCursoActivo();
    } else {
      userLogged = null;
      setMsglogin(response.resultDesc);
    }
  };

  const Img = styled("img")({
    width: 200,
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
  });

  if (!userLogged) {
    return (
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Img src={imageUrl("")} alt="random" />

            <Typography component="h1" variant="h5">
              Login
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email de murciaeduca.es"
                name="email"
                autoComplete="email"
                helperText="Si no escribes dominio se añadirá @murciaeduca.es"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
              />

              <Typography
                textAlign={"center"}
                component="h1"
                variant="h5"
                color={"red"}
              >
                {msglogin}
              </Typography>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Log In
              </Button>
              <Grid container>
                <Grid item xs sx={{ textAlign: "center" }}>
                  <Link href="#" variant="body2" onClick={handleOpen}>
                    Solicitar acceso
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
          <IaxAccessRequest
            open={open}
            onClose={handleClose}
            onAccept={handleAccept}
          />
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Container>
      </ThemeProvider>
    );
  } else {
    setTitulo("Guardias");
    navigate("/guardias/");
    //navigate("/misactividades/");
  }
}
